import { render, staticRenderFns } from "./Commande.vue?vue&type=template&id=da4c6ed2&scoped=true"
import script from "./Commande.vue?vue&type=script&lang=js"
export * from "./Commande.vue?vue&type=script&lang=js"
import style0 from "./Commande.vue?vue&type=style&index=0&id=da4c6ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4c6ed2",
  null
  
)

export default component.exports